import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '../i18n';

/**
 * Language picker modal — opened from the Avatar dropdown ("🌐 Language" row).
 *
 * When a new locale ships, drop its JSON into `/i18n/locales/` and append it to
 * `SUPPORTED_LOCALES` in `/i18n/index.js`. This picker discovers new entries
 * automatically.
 */
export default function LanguageSwitcher({ open, onClose }) {
  const { i18n, t } = useTranslation();
  if (!open) return null;
  const current = (i18n.language || 'en').split('-')[0];

  const choose = (code) => {
    i18n.changeLanguage(code);
    onClose && onClose();
  };

  return (
    <>
      <div className="ssm-scrim" onClick={onClose} data-testid="lang-scrim" />
      <div
        className="ssm-modal lang-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lang-modal-title"
        data-testid="lang-modal"
      >
        <button
          className="ssm-close"
          onClick={onClose}
          aria-label={t('common.close')}
          data-testid="lang-close"
        >
          <svg viewBox="0 0 16 16" fill="none" width="14" height="14">
            <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        <div className="lang-hero" aria-hidden="true">🌐</div>
        <h2 id="lang-modal-title" className="lang-title">{t('language.title')}</h2>
        <p className="lang-lede">{t('language.lede')}</p>
        <div className="lang-list">
          {SUPPORTED_LOCALES.map((l) => (
            <button
              key={l.code}
              type="button"
              className={`lang-row${current === l.code ? ' active' : ''}`}
              onClick={() => choose(l.code)}
              data-testid={`lang-row-${l.code}`}
            >
              <span className="lang-row-native">{l.native}</span>
              <span className="lang-row-label">{l.label}</span>
              {current === l.code && (
                <span className="lang-row-check" aria-hidden="true">✓</span>
              )}
            </button>
          ))}
        </div>
        <p className="lang-foot">{t('language.foot')}</p>
      </div>
    </>
  );
}
